/**
 * @file
 */

export function InitializeGPLMessagesDefaultPage() {
   //************************************************************************************************
   // Asp.net renders checkboxes with a SPAN element around them and moves data fields to that span. 
   // We need to put that data back into the checkbox input elements.
   //************************************************************************************************
      $('span[data-checkbox-name]').each(function () {
         var $span = $(this);
         var value = $span.data('checkbox-name');
         $span.find('input').data('checkbox-name', value);
      });
      $('span[data-select-all]').each(function () {
         var $span = $(this);
         var value = $span.data('select-all');
         $span.find('input').data('select-all', value);
      });
   //************************************************************************************************
   // If CheckAll is checked, apply to affected checkboxes.
   //************************************************************************************************
   $('.checkAll input[type="checkbox"]').on('click', function () {
      var $chkAllStatus = $(this).prop("checked");
      $('[data-name="' + $(this).data('checkbox-name') + '"] > input[type="checkbox"]').prop("checked", $chkAllStatus);
   });
   //************************************************************************************************
   // If all the elements checkAll affects are checked, CheckAll should also be checked.
   //************************************************************************************************
   $('.checkme input[type="checkbox"]').on('click', function () {
      var _selectall = $(this).prop("checked");
      var _checkAll = $('[data-name="' + $(this).data('select-all') + '"] > input[type="checkbox"]');
		if ( _selectall ) {
		   $('[data-name="' + _checkAll.data('checkbox-name') + '"] > input[type="checkbox"]').each(function (i) {
				_selectall = $(this).prop("checked");
				return _selectall;
			});
		}
		_checkAll.prop("checked", _selectall);
	});
};
